export default "__VITE_PUBLIC_ASSET__70f25fad__"